import { breakpointUpTo, throttle } from './utils.js';

(function ($) {
  // Autoplay WP video when scrolled to it
  let coverageAreaTriggered = false;
  // TODO maybe somehow make it available on other videos
  let wpVideo = $('.page-template-template-symbiotic-building .wp-video');
  if (wpVideo.length > 0 && breakpointUpTo('medium')) {
    $(window).on(
      'scroll',
      throttle(function () {
        if (!coverageAreaTriggered) {
          let scrollTop = $(window).scrollTop(),
            windowHeight = $(window).height(),
            elem = wpVideo.offset().top + 350,
            final = elem - windowHeight,
            distance = final - scrollTop;
          if (distance < 0) {
            // Video HAS TO be muted first to be able to autoplay
            wpVideo.find('video')[0].muted = true;
            wpVideo.find('.mejs-play')[0].trigger('click');
            // console.log('Load Now');
            coverageAreaTriggered = true;
          }
        }
      }, 100),
    );
  }
})(jQuery);
